module.exports = __webpack_public_path__ + "static/media/Roboto-BoldItalic.7d06e0ec.woff";